'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMoneyOff = function MdMoneyOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.9 6.8l24.3 24.4-2.1 2.1-3.7-3.8c-1 1-2.5 1.6-4 1.9v3.6h-5v-3.6c-3.2-0.7-6-2.7-6.2-6.4h3.7c0.1 2 1.5 3.5 5 3.5 2.2 0 3.4-0.8 3.9-1.6l-5.8-5.7c-3.9-1.2-6.5-3.2-6.5-6.6l-5.7-5.7z m12 4.7c-1.1 0-1.9 0.1-2.6 0.5l-2.4-2.5c0.7-0.4 1.6-0.7 2.5-0.9v-3.6h5v3.7c3.5 0.8 5.2 3.4 5.3 6.3h-3.7c-0.1-2.1-1.2-3.5-4.1-3.5z' })
        )
    );
};

exports.default = MdMoneyOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/money-off.js
// module id = 1744
// module chunks = 168707334958949